export function debounce(func: (...args: any[]) => void, timeout = 300) {
  let timer: NodeJS.Timeout;

  return function(self: any, ...args: any[]) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(self, args);
    }, timeout);
  };
}